'use client';

import { c as _c } from "react/compiler-runtime";
import { formatCents, parseCents, sanitizeMoney } from 'betterplace-utils';
import { TextInput, useIsMounted } from 'design-system/client';
import { Icon } from 'design-system/server';
import { useTranslations, useLocale } from 'next-intl';
import { useCallback, useState } from 'react';
import { useController } from 'react-hook-form';
import { type AmountFieldProps } from './types';
import type { DonationFormValues } from '@/donationForm/types';
import { useDonationFormContext } from '@/donationPages/_dependencies/helpers';
const AMOUNT_FIELD_NAME = 'amount_cents';
function DonationAmountField(t0) {
  const $ = _c(50);
  let className;
  let invisibleLabel;
  let max;
  let maxLength;
  let min;
  let minLength;
  let onBlur_;
  let props;
  let required;
  let t1;
  if ($[0] !== t0) {
    const {
      hideError: t2,
      min: t3,
      max: t4,
      maxLength: t5,
      minLength: t6,
      pattern: _,
      onBlur: t7,
      required: t8,
      className: t9,
      invisibleLabel: t10,
      ...t11
    } = t0;
    t1 = t2;
    min = t3;
    max = t4;
    maxLength = t5;
    minLength = t6;
    onBlur_ = t7;
    required = t8;
    className = t9;
    invisibleLabel = t10;
    props = t11;
    $[0] = t0;
    $[1] = className;
    $[2] = invisibleLabel;
    $[3] = max;
    $[4] = maxLength;
    $[5] = min;
    $[6] = minLength;
    $[7] = onBlur_;
    $[8] = props;
    $[9] = required;
    $[10] = t1;
  } else {
    className = $[1];
    invisibleLabel = $[2];
    max = $[3];
    maxLength = $[4];
    min = $[5];
    minLength = $[6];
    onBlur_ = $[7];
    props = $[8];
    required = $[9];
    t1 = $[10];
  }
  const hideError = t1 === undefined ? false : t1;
  const {
    control,
    formState: t2
  } = useDonationFormContext();
  const {
    errors
  } = t2;
  const locale = useLocale();
  let t3;
  if ($[11] !== max || $[12] !== maxLength || $[13] !== min || $[14] !== minLength || $[15] !== required) {
    t3 = {
      min,
      max,
      maxLength,
      minLength,
      required
    };
    $[11] = max;
    $[12] = maxLength;
    $[13] = min;
    $[14] = minLength;
    $[15] = required;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== control || $[18] !== t3) {
    t4 = {
      control,
      name: "amount_cents",
      rules: t3
    };
    $[17] = control;
    $[18] = t3;
    $[19] = t4;
  } else {
    t4 = $[19];
  }
  const {
    field: t5
  } = useController(t4);
  let field;
  let onChange_;
  let value_;
  if ($[20] !== t5) {
    const {
      onChange: t6,
      onBlur: __,
      value: t7,
      ...t8
    } = t5;
    onChange_ = t6;
    value_ = t7;
    field = t8;
    $[20] = t5;
    $[21] = field;
    $[22] = onChange_;
    $[23] = value_;
  } else {
    field = $[21];
    onChange_ = $[22];
    value_ = $[23];
  }
  const t = useTranslations("nextjs.donate.attributes");
  const mounted = useIsMounted();
  let t6;
  if ($[24] !== locale || $[25] !== value_) {
    t6 = formatCents(locale, value_, {
      format: "%v"
    });
    $[24] = locale;
    $[25] = value_;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  const [value, setValue] = useState(t6);
  let t7;
  if ($[27] !== onChange_ || $[28] !== value_) {
    t7 = t8 => {
      const {
        target
      } = t8;
      setValue(sanitizeMoney(target.value));
      const next = parseCents(target.value);
      if (next === value_) {
        return;
      }
      onChange_(next);
    };
    $[27] = onChange_;
    $[28] = value_;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  const onChange = t7;
  let t8;
  if ($[30] !== locale || $[31] !== onBlur_ || $[32] !== onChange_) {
    t8 = event => {
      if (!event.target.value) {
        onChange_(0);
        setValue(formatCents(locale, 0, {
          format: "%v"
        }));
      }
      onBlur_?.(event);
    };
    $[30] = locale;
    $[31] = onBlur_;
    $[32] = onChange_;
    $[33] = t8;
  } else {
    t8 = $[33];
  }
  const onBlur = t8;
  const errorDisplay = hideError ? "border" : "all";
  const t9 = errors[AMOUNT_FIELD_NAME]?.message;
  const t10 = !mounted;
  let t11;
  if ($[34] !== t) {
    t11 = t("amount_cents");
    $[34] = t;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Icon name="euroSign" title="Euro" color="fg-content-secondary" id={`${AMOUNT_FIELD_NAME}-suffix`} />;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== className || $[38] !== errorDisplay || $[39] !== field || $[40] !== invisibleLabel || $[41] !== onBlur || $[42] !== onChange || $[43] !== props || $[44] !== required || $[45] !== t10 || $[46] !== t11 || $[47] !== t9 || $[48] !== value) {
    t13 = <TextInput {...props} {...field} error={t9} errorDisplay={errorDisplay} className={className} inputSize="large" type="text" inputMode="decimal" value={value} onChange={onChange} onBlur={onBlur} disabled_={t10} label={t11} invisibleLabel={invisibleLabel} required={required}>{t12}</TextInput>;
    $[37] = className;
    $[38] = errorDisplay;
    $[39] = field;
    $[40] = invisibleLabel;
    $[41] = onBlur;
    $[42] = onChange;
    $[43] = props;
    $[44] = required;
    $[45] = t10;
    $[46] = t11;
    $[47] = t9;
    $[48] = value;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  return t13;
}
export { AMOUNT_FIELD_NAME };
export default DonationAmountField;